export default __webpack_public_path__ + "static/media/icon-Connect-Calendar.cf697ee2.svg";